import {
  fetchUpdateRecommendations,
  TUpdateRecommendationsResponse,
} from '../../repositories/cian-chat-bot/v1/update-recommendations';
import { IApplicationContext } from '../../types/applicationContext';

const DEGRADATION_TELEMETRY_KEY = 'degradation.chatbotUpdateRecommendations';
export async function updateRecommendations({ httpApi, logger, telemetry }: IApplicationContext): Promise<boolean> {
  try {
    const { response, statusCode }: TUpdateRecommendationsResponse = await fetchUpdateRecommendations({
      httpApi,
    });

    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);
      logger.warning('Невалидный ответ от сервера', {
        domain: 'src/shared/services/updateRecommendations/updateRecommendations.ts',
        statusCode,
        message: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });

      return false;
    }

    return true;
  } catch (error) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(error, {
      domain: 'src/shared/services/updateRecommendations/updateRecommendations.ts',
      message: 'Не удалось обновить рекомендации',
    });

    return false;
  }
}
